import type { Distance, Margins, Rectangle, RectangularCuboid } from "@pdfking/math"
import { ToMargins } from "@pdfking/math"
import { CM, MM } from "@pdfking/quantity"

export const DYNAMIC_OFFSET = MM(5)
export const MEASURE_ARROW_SIZE = MM(2)
/** A barcode keeps this far clear of every page, its own included: it stands
 * further off its own page than this. */
export const BARCODE_MIN_DISTANCE = MM(2)

/**
 * 1mm on each edge: the form's initial `security_margins`, and what a
 * component with none keeps. Python's `SECURITY_AREA_DEFAULT` (sizes.py:41-43)
 * is 5mm; the TS is the reference.
 */
export const SECURITY_AREA_DEFAULT: Margins<Distance> = ToMargins(CM(1))

// --- Mirrors of Python pdfengine sizes.py constants (TODO: de-hardcode TS callers) ---

export const DEFAULT_PADDING: Distance = MM(1)
/** The bleed a file gets when none is given. */
export const DEFAULT_FILE_BLEED: Distance = MM(5)

export const DEFAULT_SIZE: Rectangle<Distance> = {
  width: CM(21),
  height: CM(29.7),
}

export const DEFAULT_SIZE_3D: RectangularCuboid<Distance> = {
  width: CM(21),
  height: CM(29.7),
  depth: CM(10),
}
